/**
 * Inline SVG logo for Zombie-Killer.
 *
 * Motif: crosshair reticle with biohazard-inspired inner ring.
 * Minimalist, bold silhouette. Works at 24px (favicon) to 120px (hero).
 * Colors: terminal-green (#44cc44) + white, optional size parameter.
 */

/**
 * Returns the SVG logo markup as a string.
 * @param size CSS width/height (default '48px')
 * @param color Primary stroke/fill color (default 'currentColor')
 */
export function logoSvg(size = '48px', color = 'currentColor'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
    width="${size}" height="${size}" fill="none" stroke="${color}"
    stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
    aria-hidden="true" role="img">
    <!-- Outer crosshair ring -->
    <circle cx="50" cy="50" r="42" opacity="0.4"/>
    <circle cx="50" cy="50" r="36" stroke-width="2.5"/>
    <!-- Crosshair lines -->
    <line x1="50" y1="4" x2="50" y2="22"/>
    <line x1="50" y1="78" x2="50" y2="96"/>
    <line x1="4" y1="50" x2="22" y2="50"/>
    <line x1="78" y1="50" x2="96" y2="50"/>
    <!-- Tick marks -->
    <line x1="50" y1="22" x2="50" y2="28" stroke-width="2" opacity="0.6"/>
    <line x1="50" y1="72" x2="50" y2="78" stroke-width="2" opacity="0.6"/>
    <line x1="22" y1="50" x2="28" y2="50" stroke-width="2" opacity="0.6"/>
    <line x1="72" y1="50" x2="78" y2="50" stroke-width="2" opacity="0.6"/>
    <!-- Biohazard inner trefoil (3 arcs) -->
    <path d="M50 32 A12 12 0 0 1 60.4 44" stroke-width="4" fill="none"/>
    <path d="M60.4 44 A12 12 0 0 1 50 56" stroke-width="4" fill="none" transform="rotate(120 50 50)"/>
    <path d="M50 32 A12 12 0 0 1 60.4 44" stroke-width="4" fill="none" transform="rotate(240 50 50)"/>
    <!-- Center dot -->
    <circle cx="50" cy="50" r="3" fill="${color}" stroke="none"/>
  </svg>`;
}
